export default __webpack_public_path__ + "static/media/02.6f017c1b.png";